export default __webpack_public_path__ + "static/media/phone.c78e72db.svg";